
(function () {
  'use strict';
  console.log('🚀 [Mate Health] Global ATC Engine Script Loaded Successfully.');

  function forceOpenDrawer() {
    console.log('⚡ [Mate Health] Initializing drawer trigger sequence...');
    var drawerRoot = document.querySelector('drawer-root, .drawer--root');
    var body = document.body;

    if (drawerRoot) {
      drawerRoot.setAttribute('aria-expanded', 'true');
      drawerRoot.classList.add('drawer--open');
      
      var targets = drawerRoot.querySelectorAll('.drawer--instance, [data-side="right"]');
      targets.forEach(function(el) {
        el.setAttribute('aria-expanded', 'true');
        el.classList.add('drawer--open');
      });
      
      if(body) {
        body.classList.add('overflow-hidden');
        body.setAttribute('data-drawer-open', 'true');
      }

      // Propagate native framework update listeners
      drawerRoot.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      return true;
    }

    // Secondary selector click targeting strategy
    var targetToggle = document.querySelector(
      '[data-drawer-toggle="cart"], .header__cart-toggle, [aria-controls="cart-drawer"], .header__cart-button, [data-drawer-target="cart"], .cart-icon-bubble'
    );
    if (targetToggle) {
      targetToggle.click();
      return true;
    }
    return false;
  }

  /* ─────────────────────────────────────────────────────────────
     Event Delegation Engine (Listens globally across sections)
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mhp-atc');
    if (!btn || btn.classList.contains('mhp-btn--loading')) return;

    e.preventDefault();
    console.log('🛒 [Mate Health] Click detected on ATC element.');

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('❌ [Mate Health] Action aborted: missing Variant ID string.');
      return;
    }

    var originalText = btn.textContent.trim();
    btn.classList.add('mhp-btn--loading');
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding\u2026';

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    // Form payload parameters structured to match theme schema identifiers
    var formData = {
      'id': parseInt(variantId, 10),
      'quantity': 1,
      'sections': 'cart-root,main-cart,cart-drawer'
    };

    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) { throw err; });
      }
      return res.json();
    })
    .then(function (responseContent) {
      console.log('✅ [Mate Health] Shopify API Response 200 OK:', responseContent);

      // Re-render HTML nodes inside theme wrapper sections dynamically
      if (responseContent.sections) {
        Object.keys(responseContent.sections).forEach(function(sectionKey) {
          var domTarget = document.querySelector('#shopify-section-' + sectionKey + ' .cart--root, [data-section-id="' + sectionKey + '"]');
          if (domTarget && responseContent.sections[sectionKey]) {
            domTarget.innerHTML = responseContent.sections[sectionKey];
          }
        });
      }

      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: responseContent } }));
      document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { item: responseContent } }));

      return fetch(cartRoot + 'cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cartData) {
      // Sync global line counts visible on screen layout headers
      document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, .header__cart-count, [data-item-count], .cart-icon-bubble').forEach(function (el) { 
        el.textContent = cartData.item_count; 
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
      document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { cart: cartData } }));
      
      btn.textContent = 'Added ✓';
      var opened = forceOpenDrawer();
      
      setTimeout(function () {
        btn.classList.remove('mhp-btn--loading');
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
        if(!opened) {
          console.warn('⚠️ [Mate Health] Drawer container missing, falling back to page redirect.');
          window.location.href = '/cart';
        }
      }, 1000);
    })
    .catch(function (error) {
      console.error('❌ [Mate Health] Operation failed:', error);
      window.location.href = '/cart';
    });
  });

  /* Intersection Animation Observer Initialization */
  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('.mhp-card');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var delay = parseInt(entry.target.getAttribute('data-delay') || '0', 10);
          entry.target.style.animationDelay = delay + 'ms';
          entry.target.classList.add('mhp-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('mhp-visible'); });
    }
  });
})();